// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1DUmm","additionalInfo":"AgreementModal_additionalInfo__3Aryp"};